import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetBooked } from "../../features/bookings/hotelSlice";
import { resetTransferBooked } from "../../features/bookings/transferSlice";
import { resetCarrentBooked } from "../../features/bookings/carrentSlice";
import { resetInsuranceStaus } from "../../features/bookings/insuranceSlice";
import {
  resetAirBooked,
  ResetLoader,
} from "../../features/bookings/flightSlice";
import { getNotificationAsync } from "../../features/userSlice";
import { useEffect } from "react";

const SuccessModal = ({ setShow, show, msg, status, statusCode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};

  useEffect(() => {
    dispatch(getNotificationAsync(Authorization));
  }, []);

  const redirectWithReset = (val) => {
    switch (val) {
      case "/hotel":
        dispatch(resetBooked());
        navigate("/hotel");
        break;
      case "/flight":
        dispatch(resetAirBooked());
        dispatch(ResetLoader());
        navigate("/flight");
        break;
      case "/transfer":
        dispatch(resetTransferBooked());
        navigate("/transfer");
        break;
      case "/carrent":
        dispatch(resetCarrentBooked());
        navigate("/carrent");
        break;
      case "/insurance":
        dispatch(resetInsuranceStaus());
        navigate("/");
        break;
    }
  };

  const formSubmit = () => {
    // navigate({ pathname: "/", replace: true });

    redirectWithReset(window.location.pathname.split("-")[0]);

    // if (window.location.pathname.includes("transfer")) {
  };

  return (
    <>
      <div
        className={`modal my-auto ${show ? "d-flex" : "d-none"} shadow-none`}
        id="reset-password-Modal"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              {/*  */}
              <form className="cmn-form login-form confirmed-booking">
                <div className="form-title text-center">
                  <h2>{status}</h2>
                </div>

                {parseInt(statusCode) === 300 ? (
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <img
                      src="./assets/images/process.svg"
                      alt="processing"
                      style={{ maxWidth: "150px" }}
                    />
                  </div>
                ) : parseInt(statusCode) === 200 ? (
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <img
                      src="./assets/images/confirmation.svg"
                      alt="success"
                      style={{ maxWidth: "150px" }}
                    />
                  </div>
                ) : (
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <img
                      src="./assets/images/error.svg"
                      alt="failed"
                      style={{ maxWidth: "150px" }}
                    />
                  </div>
                )}

                <div className="text-center">
                  <p>{msg}</p>
                </div>

                <div className="form-group text-center m-0 d-flex justify-content-center">
                  <button
                    className="cmn-btn form-btn inputbtn "
                    onClick={formSubmit}
                    type="button"
                  >
                    Ok
                  </button>
                </div>
              </form>
              {/*  */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessModal;
